import React from 'react';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  onlyBold: {
    fontWeight: 'bold',
    fontSize: 15,
    textAlign: 'justify',
    marginVertical: 0,
  },
}));

function Bold(props) {
  const classes = useStyles();

  return <Typography className={classes.onlyBold}>{props.text}</Typography>;
}

export default Bold;
